import {URL_BASE} from './rutasFijas';

export { productosAPI, destinosAPI, reservasAPI, toolsAPI, usuariosAPI, cobranzasAPI, archivoCVAPI, 
  notificacionesWebAPI, chartersAPI, pruebaAPI, cdrAPI, facturaAPI, gestionesComercialesAPI };

function productosAPI (data) {
  const url = `${URL_BASE}/productosServicios.php`;

  return realizarPeticion(url, data);
}

function chartersAPI (data) {
  const url = `${URL_BASE}/chartersServicios.php`;

  return realizarPeticion(url, data);
}


function destinosAPI (data) {
  const url = `${URL_BASE}/destinosServicios.php`;

  return realizarPeticion(url, data);
}

function cdrAPI (data) {
  const url = `${URL_BASE}/cdrServicios.php`;

  return realizarPeticion(url, data);
}

function toolsAPI(data) {
  const url = `${URL_BASE}/toolsServicios.php`;

  return realizarPeticion(url, data);
}

function facturaAPI(data) {
  const url = `${URL_BASE}/facturaServicios.php`;

  return realizarPeticion(url, data);
}

function reservasAPI (data) {
  const url = `${URL_BASE}/reservasServicios.php`;

  return realizarPeticion(url, data);
}

function cobranzasAPI (data) {
  const url = `${URL_BASE}/cobranzasServicios.php`;

  return realizarPeticion(url, data);
}

function usuariosAPI (data) {
  const url = `${URL_BASE}/usuariosServicios.php`;

  return realizarPeticion(url, data);
}

function archivoCVAPI(data) {
  const url = `${URL_BASE}/archivoCVServicios.php`;

  return realizarPeticion(url, data);
}

function notificacionesWebAPI(data) {
  const url = `${URL_BASE}/notificacionesWebServicios.php`;

  return realizarPeticion(url, data);
}

function gestionesComercialesAPI(data) {
  const url = `${URL_BASE}/serviciosGestionesComerciales.php`;

  return realizarPeticion(url, data);
}

function realizarPeticion (url , data) {
    let fetchData = {
        method: 'POST',
        body: data,
        //credentials: 'same-origin',
        /*headers:{
            'Content-Type': 'application/json'
          }*/
        headers: new Headers()
    }

    return fetch(url, fetchData)
            .then(response => {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .catch(error => console.log('error:', error));
}

function pruebaAPI(data){
    const url = `${URL_BASE}/reservasServicios.php`;
    return realizarPeticion(url, data);
}



// WEBPACK FOOTER //
// ./src/utils/funcionesAPI.js